<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Item Box</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur" class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="filter.noFaktur"
                                maxlength="50"
                                @keydown.enter="getItems"
                                placeholder="Cari No. Faktur..."
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Status Approval">
                        <b-input-group>
                            <b-form-select
                                id="filter-status"
                                v-model="filter.status"
                                :options="optStatus"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Aksi">
                        <div
                            class="d-flex flex-nowrap d-flex justify-content-between"
                        >
                            <b-button variant="primary" @click="getItems">
                                <i class="fa fa-search mr-2" />Cari
                            </b-button>

                            <b-button
                                v-if="box && box.status !== 0"
                                size="sm"
                                :variant="
                                    box.marked_video_url ? 'warning' : 'danger'
                                "
                                @click="showModal"
                            >
                                <i
                                    :class="
                                        box.marked_video_url
                                            ? 'fa fa-fw fa-eye'
                                            : 'fa fa-fw fa-exclamation-triangle'
                                    "
                                />
                                {{
                                    box.marked_video_url
                                        ? "Lihat Detail Suspect"
                                        : "Tandai Suspect"
                                }}
                            </b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(dry_weight)="row">
                    {{ row.item.dry_weight || "-" }} gr
                </template>
                <template v-slot:cell(weight_reduction)="row">
                    {{ row.item.weight_reduction || "-" }} gr
                </template>
                <template v-slot:cell(item_brand)="row">
                    {{ row.item.item_brand || "-" }}
                </template>
                <template v-slot:cell(gold_type)="row">
                    {{ row.item.gold_type || "-" }}
                </template>
                <template v-slot:cell(carat)="row">
                    {{ row.item.carat ? row.item.carat + "K" : "-" }}
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge
                        :variant="getStatusBadge(row.item.approval_status)[0]"
                    >
                        {{ getStatusBadge(row.item.approval_status)[1] }}
                    </b-badge>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <ModalSuspectBox
            ref="modalSuspectBox"
            :item="selectedItem"
            @refresh-items="getItems(currentPage)"
        />
    </div>
</template>

<script>
import ModalSuspectBox from "./ModalSuspectBox.vue";

export default {
    components: {
        ModalSuspectBox
    },
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isBusy: true,
            isShowing: false,

            data: {},
            items: [],

            filter: {
                noFaktur: null,
                status: null
            },


            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            optStatus: [
                { value: null, text: "Semua" },
                { value: 0, text: "PENDING" },
                { value: 1, text: "APPROVED" },
                { value: 99, text: "VARIANCE" }
            ],

            currentPage: 1,
            perPage: 10,

            totalRows: 0,

            box: null,
            selectedItem: null
        };
    },

    computed: {
        fields() {
            const base = [
                { key: "no_faktur", label: "No. Faktur", sortable: false },
                { key: "purity", label: "Kadar", sortable: false },
                { key: "dry_weight", label: "Berat Kotor", sortable: false },
                { key: "weight_reduction", label: "Berat Potongan", sortable: false },
                { key: "item_kind", label: "Jenis Item", sortable: false },
                { key: "item_brand", label: "Merk Item", sortable: false },
                { key: "gold_type", label: "Jenis Emas", sortable: false },
            ];
            if (this.box && this.box.source === "RBE") {
                base.push({ key: "carat", label: "Karat", sortable: false });
            }
            base.push({ key: "status", label: "Status Approval", sortable: false });
            return base;
        }
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page) {
            this.isBusy = true;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
            );

            if (this.filter.noFaktur) {
                param += `&filterNoFaktur=${this.filter.noFaktur}`;
            }

            if (this.filter.status != null) {
                param += `&filterStatus=${this.filter.status}`;
            }

            return this.$axios
                .get(
                    "/gold-deliveries/box/" +
                        this.$route.params.id +
                        "/items" +
                        param
                )
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;

                    this.box = {
                        ...res.data.data.box,
                        id:
                            (res.data.data.box && res.data.data.box.id) ||
                            this.$route.params.id,
                        box_code:
                            (res.data.data.box && res.data.data.box.box_code) ||
                            "BOX-" + this.$route.params.id
                    };
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                });
        },

        showModal() {
            this.selectedItem = this.box || {
                id: this.$route.params.id,
                box_code: "BOX-" + this.$route.params.id
            };
            this.$nextTick(() => {
                this.$refs.modalSuspectBox.$bvModal.show("m-suspect-box");
            });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        getStatusBadge(status) {
            switch (status) {
                case 0:
                    return ["warning", "PENDING"];
                case 1:
                    return ["success", "APPROVED"];
                case 99:
                    return ["danger", "VARIANCE"];
                default:
                    return ["light", "-"];
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style></style>
